import { keyframes, styled } from 'stitches.config'

const progressAnimation = keyframes({
  '100%': {
    width: '100%',
  },
})

export const LoadingInterstitialRoot = styled('div', {

  '&.cv-1-2-popup-closed': {
    overflow: 'hidden',
    position: 'fixed',
    width: '100%',
    left: '0',
    right: '0',
  },

  '& .cv-1-2-crafting-popup': {
    position: 'fixed',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    overflowX: 'hidden',
    overflowY: 'auto',
    zIndex: '9999999',
    background: ' rgb(35 26 26 / 40%)',
    display: 'none',
  },

  '&.cv-1-2-popup-open .cv-1-2-crafting-popup': {
    display: 'block',
    padding: '$4',
    '@bpInt': {
      padding: '0',
    }
  },

  '& .cv-1-2-crafting-plan': {
    width: '100%',
    height: '100%',
    display: 'table',
  },

  '& .cv-1-2-container': {
    display: 'table-cell',
    verticalAlign: 'middle',
    padding: '0 16px',
  },

  '& .cv-1-2-container .crafting-plan-popup': {
    width: '100%',
    maxWidth: '679px',
    margin: '95px auto 50px',
    background:
      'linear-gradient(0deg, #fff 0%, #fff 100%), linear-gradient(to bottom right, rgba(251, 249, 240, 0.5) 0%, rgba(243, 234, 210, 0.5) 50%) bottom right / 50% 50% no-repeat, linear-gradient(to bottom left, rgba(251, 249, 240, 0.5) 0%, rgba(243, 234, 210, 0.5) 50%) bottom left / 50% 50% no-repeat, linear-gradient(to top left, rgba(251, 249, 240, 0.5) 0%, rgba(243, 234, 210, 0.5) 50%) top left / 50% 50% no-repeat, linear-gradient(to top right, rgba(251, 249, 240, 0.5) 0%, rgba(243, 234, 210, 0.5) 50%) top right / 50% 50% no-repeat, #fbf9f1',
    borderRadius: '16px',
    '@bpInt': {
      borderRadius: '8px',
    },
  },

  '& .cv-1-2-container .popup-logo': {
    width: '100%',
    maxWidth: '90px',
    margin: '0 auto',
    transform: 'translateY(-2rem)',
    border: '1px solid #fff',
    borderRadius: '50%',
    '@bpInt': {
      maxWidth: '70px',
    },
  },

  '& .cv-1-2-container .popup-logo img': {
    marginTop: '-45px',
    marginBottom: '29px',
    width: '100%',
    '@bpInt': {
      marginTop: '-35px',
      marginBottom: '27px',
    },
  },

  '& .cv-1-2-container h1': {
    color: '$accent-black',
    textAlign: 'center',
    fontFamily: '$display',
    fontSize: '32px',
    fontWeight: '300',
    lineHeight: '120%',
    padding: '0 24px',
    width: '100%',
    maxWidth: '580px',
    margin: '0 auto 24px',
    '@bpInt': {
      marginBottom: '24px',
      maxWidth: '350px',
    },
  },

  '& .cv-1-2-container .crafting-plan-top': {
    paddingTop: '32px',
  },

  '& .cv-1-2-container .crafting-plan-top > img': {
    width: '100px',
    height: '100px',
    margin: '0 auto 20px',
    display: 'block',
    '@bpInt': {
      width: '90px',
      height: '90px',
    },
  },

  '& .cv-1-2-container .crafting-plan-top .crafting-plan-teddy': {
    textAlign: 'center',
  },

  '& .cv-1-2-container .progress-bar': {
    height: '12px',
    background: '#f4ecd3',
    boxShadow: '0px 0px 1px 0px rgba(0, 0, 0, 0.4) inset',
    width: '380px',
    borderRadius: '10px',
    overflow: 'hidden',
    margin: '24px auto 24px',
    '@bpInt': {
      width: 'calc(100% - 80px)',
      maxWidth: '380px',
      marginBottom: '24px',
    },
  },

  '&.cv-1-2-popup-open .cv-1-2-container .progress-fill': {
    width: '0%',
    height: '100%',
    backgroundColor: '#ec3825',
    animation: `${progressAnimation} 5s ease-in-out forwards`,
  },

  '&.cv-1-2-popup-open .cv-1-2-container .fill-fast': {
    animation: `${progressAnimation} 1s ease-in-out forwards`,
  },

  '& .cv-1-2-container .crafting-plan-bottom': {
    background: '$tertiary-200',
    padding: '32px',
    position: 'relative',
    borderRadius: '0 0 16px 16px',
    overflow: 'hidden',
    '@bpInt': {
      padding: '31px 24px 32px',
      borderRadius: '0 0 8px 8px',
    },
  },

  '& .cv-1-2-container .crafting-plan-data': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'column',
    '@bpInt': {
      flexDirection: 'column',
    },
  },

  '.cv-1-2-container .plan-content': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '24px',

    '@bpInt': {
      width: '100%',
      display: 'flex',
      marginBottom: '24px',
    },
  },

  '.cv-1-2-container .plan-content:last-child': {
    marginBottom: 0,
    '@bpInt': {
      marginBottom: 0,
    },
  },

  '& .cv-1-2-container .plan-content .icon': {
    display: 'flex',
    justifyContent: 'center',
    width: '70px', 
  },

  '& .cv-1-2-container .plan-content p': {
    color: '$accent-black',
    textAlign: 'left',
    fontFamily: '$primary',
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '26px',
    width: '300px',
    '@bpInt': {
      textAlign: 'left',
      width: '100%',
      maxWidth: '200px',
    },
  },

  '& .cv-1-2 .cv-1-2-primary': {
    backgroundColor: '#ec3825',
    padding: '16px 32px',
    borderRadius: '$1',
    color: ' #fff !important',
    fontWeight: '600',
    lineHeight: 'normal',
    marginTop: '0 !important',
    textAlign: 'center',
    textDecoration: 'none',
    height: '56px',
    display: 'flex',
    alignItems: 'center',
  },

  '& .cv-1-2 .cv-1-2-primary[disabled]': {
    backgroundColor: '#ffb1a9',
    cursor: 'not-allowed',
  },

  '7 .cv-1-2 .cv-1-2-primary[disabled]:hover': {
    backgroundColor: '#ffb1a9',
  },

  '& .cv-1-2 .cv-1-2-primary:hover': {
    backgroundColor: '#ee4c3b',
  },

  '& svg': {
    color: 'red',
  }
})
